export default "__VITE_ASSET__DRfY3ZXj__"